import {
    BATCH_OPERATE_SECONDARY_BUSINESS,
    CLEAR_SECONDARY_BUSINESS_ACTION,
    DELETE_SECONDARY_BUSINESS_ACTION,
    SELECT_SECONDARY_BUSINESS_ACTION
} from '../../../actionType';

export default function (state = [], action) {
    switch (action.type) {
        case SELECT_SECONDARY_BUSINESS_ACTION:
            return [
                ...state,
                {
                    commodityCode: action.id,
                    commodityName: action.commodityCategoryName,
                    key: action.id,
                    isLeaf: action.isLeaf,
                    selectAll: action.selectAll,
                }
            ];
        case DELETE_SECONDARY_BUSINESS_ACTION:
            state.splice(action.index,1);
            return [...state];
        case BATCH_OPERATE_SECONDARY_BUSINESS:
            return [...action.gridData];
        case CLEAR_SECONDARY_BUSINESS_ACTION:
            return [];
        default:
            return state;
    }
}
